import { render } from "./THead.vue?vue&type=template&id=36e6ce78"
import script from "./THead.vue?vue&type=script&lang=js"
export * from "./THead.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__